import { useAuth0 } from '@auth0/auth0-react';
import { useTranslation } from 'react-i18next';
import { Modal, Checkbox } from 'antd';
import { useState } from 'react';
import styles from './DownloadsPage.module.less';
import unrealIcon from 'assets/img/unreal-logo-icon.png';
import unityIcon from 'assets/img/unity-logo-icon.png';
import omniIcon from 'assets/img/omni-logo-icon-only.png';
import githubIcon from 'assets/img/github-logo-icon.png';
import SdkEula from './SdkEula';

export default function DownloadsPage() {
	const { loginWithRedirect } = useAuth0();
	const { t } = useTranslation();
	const [unityModalVisible, setUnityModalVisible] = useState(false);
	const [unrealModalVisible, setUnrealModalVisible] = useState(false);
	const [sdkButtonText, setSdkButtonText] = useState('Download SDK');

	// Show/Hide SDK EULA Modal for Unity SDK
	const showUnityEula = () => {
		setUnityModalVisible(true);
	};

	const hideUnityEula = () => {
		setUnityModalVisible(false);
	};

	const hideUnityEulaDelay = () => {
		setSdkButtonText('Your download will begin in a moment');
		setTimeout(() => {
			setUnityModalVisible(false);
		}, 2000);
		setTimeout(() => {
			setSdkButtonText('Download SDK');
		}, 2000);
	};

	// Switch state on click for Download Unity SDK button
	const [checkedUnity, setCheckedUnity] = useState(false);

	const handleCheckboxChangeUnity = () => {
		setCheckedUnity(!checkedUnity);
	};

	// Show/Hide SDK EULA Modal for Unreal SDK
	const showUnrealEula = () => {
		setUnrealModalVisible(true);
	};

	const hideUnrealEula = () => {
		setUnrealModalVisible(false);
	};

	const hideUnrealEulaDelay = () => {
		setSdkButtonText('Your download will begin in a moment');
		setTimeout(() => {
			setUnrealModalVisible(false);
		}, 2000);
		setTimeout(() => {
			setSdkButtonText('Download SDK');
		}, 2000);
	};

	// Switch state on click for Download Unreal SDK button
	const [checkedUnreal, setCheckedUnreal] = useState(false);

	const handleCheckboxChangeUnreal = () => {
		setCheckedUnreal(!checkedUnreal);
	};

	return (
		<>
			<div className={styles.DownloadsPageContainer}>
				<h1 className={styles.DownloadsPageTitle}>Downloads</h1>
				<div className={styles.DownloadsPageDisplayRow}>
					<div className={styles.DownloadsPageDisplayColumn}>
						<div className={styles.DownloadsPageCard}>
							<div className={styles.DownloadsPageCardIconsTop}>
								<img src={omniIcon} className={styles.DownloadsPageCardIcon} />
								<img src={unrealIcon} className={styles.DownloadsPageCardIcon} />
							</div>
							<p className={styles.DownloadsPageHeader}>Omni One SDK for Unreal</p>
							<p>Bring your Unreal content to Omni One.</p>
							<button className={styles.DownloadsPageButton} onClick={showUnrealEula}>
								Download
							</button>
						</div>
					</div>
					<div className={styles.DownloadsPageDisplayColumn}>
						<div className={styles.DownloadsPageCard}>
							<div className={styles.DownloadsPageCardIconsTop}>
								<img src={omniIcon} className={styles.DownloadsPageCardIcon} />
								<img src={unityIcon} className={styles.DownloadsPageCardIcon} />
							</div>
							<p className={styles.DownloadsPageHeader}>Omni One SDK for Unity</p>
							<p>Bring your Unity content to Omni One.</p>
							<button className={styles.DownloadsPageButton} onClick={showUnityEula}>
								Download
							</button>
						</div>
					</div>
				</div>
			</div>
			<Modal
				title="Omni One SDK - Read and Accept Terms"
				width={960}
				visible={unityModalVisible}
				footer={null}
				onCancel={hideUnityEula}
			>
				<SdkEula />
				<Checkbox checked={checkedUnity} onChange={handleCheckboxChangeUnity}>
					I agree to the terms and conditions
				</Checkbox>
				<br />
				<a href="https://assets.omni.virtuix.com/sdk-assets/unity-sdk/Omni_One_Unity_SDK_v1.1.3.zip" rel="noreferrer" download>
					<button className={styles.DownloadsPageButtonSdk} disabled={!checkedUnity} onClick={hideUnityEulaDelay}>
						{sdkButtonText}
					</button>
				</a>
			</Modal>
			<Modal
				title="Omni One SDK - Read and Accept Terms"
				width={960}
				visible={unrealModalVisible}
				footer={null}
				onCancel={hideUnrealEula}
			>
				<SdkEula />
				<Checkbox checked={checkedUnreal} onChange={handleCheckboxChangeUnreal}>
					I agree to the terms and conditions
				</Checkbox>
				<br />
				<a href="https://assets.omni.virtuix.com/sdk-assets/unreal-sdk/OmniOneSDK_UE_v1.1.3.zip" rel="noreferrer" download>
					<button className={styles.DownloadsPageButtonSdk} disabled={!checkedUnreal} onClick={hideUnrealEulaDelay}>
						{sdkButtonText}
					</button>
				</a>
			</Modal>
		</>
	);
}
